import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.selectTarget.addEventListener("change", this.redirect.bind(this));
  }

  redirect(event) {
    const selectedValue = event.target.value;
    const urlPath = this.element.dataset.urlPath;
    const url = `${urlPath}?filter=${selectedValue}`;
    window.location.href = url;
  }
}
